export default "__VITE_ASSET__CRXD8_lE__"